/**
 * Copyright 2025 Beijing Volcano Engine Technology Co., Ltd. All Rights Reserved.
 * SPDX-license-identifier: BSD-3-Clause
 */

import { useDispatch, useSelector } from 'react-redux';
import { RootState } from '@/store';
import CheckScene from './CheckScene';
import { SceneConfig, updateScene } from '@/store/slices/room';
import { useScene } from '@/lib/useCommon';
import style from './index.module.less';

function AIChangeCard() {
  const { scene, sceneConfigMap } = useSelector((state: RootState) => state.room);
  const dispatch = useDispatch();
  const { icon } = useScene();
  const Scenes = Object.keys(sceneConfigMap).map(key => sceneConfigMap[key]);

  const handleChecked = (checkedScene: string) => {
    dispatch(updateScene(checkedScene));
  };

  return (
    <div className={style.card}>
      <div className={style.avatar}>
        <img id="avatar-card" src={icon} alt="Avatar" />
      </div>
      {/* <div className={style.title}>
        <div>KeepNIU问医</div>
      </div> */}
       <div className={style['desc-doctor-info']}>
        华西医院 袁波 (副主任医师 | 全科门诊 ) <span className={style['desc-doctor-tag']}>Ai医生</span> 
      </div>

       <div className={style['desc-info']}>
        您好。我是依托大量医学教材，并结合华西医院全科医学科袁波医生多年诊疗经验训练而成的AI助手。擅长常见病、多发病、症状未分化疾病的诊治；疾病早期筛查、健康管理及评估。呼吸系统慢性病管理。若您有疾病或健康相关的问题，欢迎随时咨询。
      </div>

      <div className={style.sceneContainer} style={{ display: 'none' }}>
        {Scenes.map((key: SceneConfig) =>
          <CheckScene
            key={key.name}
            icon={key.icon}
            title={key.name}
            checked={key.id === scene}
            onClick={() => handleChecked(key.id)}
          />
        )}
      </div>
    </div>
  );
}

export default AIChangeCard;
